import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ServiceTypes;

export const statusSelector = createSelector(rootSelector, (serviceTypesRoot) => serviceTypesRoot.status);

export const errorSelector = createSelector(rootSelector, (serviceTypesRoot) => serviceTypesRoot.error);

export const serviceTypesSelector = createSelector(rootSelector, (serviceTypesRoot) => serviceTypesRoot.data);

export default {
  statusSelector,
  errorSelector,
  serviceTypesSelector,
};
